import { render, staticRenderFns } from "./SessionConfigDialog.vue?vue&type=template&id=e813f8c6&"
import script from "./SessionConfigDialog.vue?vue&type=script&lang=js&"
export * from "./SessionConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports